
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import Vue from 'vue'

var DetailFileCom = Vue.extend({})

Vue.component('detail-file', DetailFileCom)

export default {
  name: 'DetailFile',
  props: [
    'fileData'
    // 'fileList'
  ],
  components: {
    XTable,
    XButton
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      fileUrl: ''// 附件-文件地址（供复制）
    }
  },
  mounted () {
    console.log(this.fileData)
  },
  methods: {
    showFile (index, url, type, fileName) { // 查看附件
      debugger
      this.fileUrl = ''
      let typeStr = type.toLowerCase().slice(-3)
      if (typeStr === 'jpg' || typeStr === 'png' || typeStr === 'gif' || typeStr === 'peg') { // 图片
        // let imgLinkArr = []// 图片流地址
        // let imgArr = this.fileList
        let imgLink// 需要展示的图片流
        // for (var i in imgArr) {
        //   imgLinkArr.push(imgArr[i].src)
        // }
        imgLink = this.fileData[index].fileSrc // imgLinkArr[index]

        this.$vux.loading.show({
          text: '加载中'
        })
        this.axios({
          url: this.baseUrl + imgLink,
          method: 'get'
        }).then((response) => {
          this.$vux.loading.hide()
          let showImg = this.baseUrl + '/' + response.data.filePath// 需要展示的图片地址
          let showImgArr = []

          showImgArr.push(showImg)
          setTimeout(() => {
            wx.previewImage({
              current: showImg, // 当前显示图片的http链接
              urls: showImgArr // 需要预览的图片http链接列表
            })
          }, 500)
        }).catch((response) => {
          this.$vux.loading.hide()
        })
      } else { // 文档
        // let fileLinkArr = []// 文件流地址
        // let fileArr = this.fileList
        let fileLink// 需要展示的文件流
        let loadFile
        // for (const i in fileArr) {
        //   fileLinkArr.push(fileArr[i].src)
        // }
        fileLink = this.fileData[index].fileSrc

        this.$vux.loading.show({
          text: '加载中'
        })
        console.log(this.fileData)
        console.log(fileLink)
        debugger
        this.axios({
          url: this.baseUrl + fileLink,
          method: 'get'
        }).then((response) => {
          this.$vux.loading.hide()
          debugger
          if (response.data.status === true) {
            loadFile = this.baseUrl + '/' + response.data.filePath// 需要展示的文档地址
            console.log('预览文件地址：' + loadFile)
            this.fileUrl = loadFile
            this.$router.push({
              path: '/seefile',
              query: {
                loadFile: this.fileUrl,
                fileName: fileName
              }
            })
          }
        }).catch((response) => {
          this.$vux.loading.hide()
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/File.vue